import VueI18n from 'vue-i18n';
import Helpers from '@/utils/Helpers.js';

const messages = {
	'en': {
		spotListHeader: "Spot List",
		approxDistance: 'approx.',
		distUnit: 'mile|miles',
		distUnitAbr: 'm.',
		search: "Search...",
		fileSelectDialogSelectFileTitle: "Select Files to print...",
		fileSelectDialogUserFormTitle: "Enter your email",
		fileSelectDialogMessage: 'Drop file here or <em>click to upload</em>',
		fileUploadSizeDisclaimer: 'Files with a size less than {maxSize} Mb',
		genCancel: "Cancel",
		genSubmit: "Submit",
		genBack: 'Back',
		genNext: "Next",
		genOk: "Ок",
		printCTA: "Print",
		mailCTA: "Print",
		paperName: "Paper",
		profileCost: "Price",
		priceFree: "Free",
		uploadStepName: "Step 1",
		emailStepName: "Step 2",
		userFormEmail: "Email",
		errMsgUserFormEmailRequired: 'Please input your email address',
		userFormComment: 'Comments',
		jobLoadingFormTitle: "Uploading Files...",
		jobCreatedFormTitle: 'Job Created',
		jobCreatedFormHeading: 'Congratulations!',
		accessCode: 'Access Code',
		congratsHtmlTemplate: 
		`<p>You successfully submitted a print job to <em>“{name}”</em> located at <em>{address}</em>.</p> 
		<p>Please use the code <em>{accessCode}</em> when requesting the printout.</p>
		<p>We also sent this message to your email <em>{email}</em></p>`,
		language: "Language",
		disclaimerInstallAppTitle: "Install Mobile App",
		disclaimerInstallAppText: "Our mobile app is handy. Install it?",
	},
	'ru': {
		spotListHeader: 'Список Спотов',
		approxDistance: 'примерно ',
		distUnit: 'километр|километров',
		distUnitAbr: 'км.',
		search: "Поиск...",
		fileSelectDialogSelectFileTitle: "Выберите файлы для печати...",
		fileSelectDialogUserFormTitle: "Введите свой email",
		fileSelectDialogMessage: 'Перетащите файл или <em>кликните для загрузки</em>',
		fileUploadSizeDisclaimer: 'Файлы размером не более {maxSize} Мб',
		genCancel: "Отмена",
		genSubmit: "Подтвердить",
		genBack: 'Назад',
		genNext: "Далее",
		genOk: "Ок",
		printCTA: "НАПЕЧАТАТЬ",
		mailCTA: "НАПЕЧАТАТЬ",
		paperName: "Бумага",
		profileCost: "Цена",
		priceFree: "Бесплатно",
		uploadStepName: "Шаг 1",
		emailStepName: "Шаг 2",
		userFormEmail: "Email",
		errMsgUserFormEmailRequired: 'Пожалуйста введите свой адрес электронной почты',
		userFormComment: 'Комментарии',
		jobLoadingFormTitle: "Загрузка файлов...",
		jobCreatedFormTitle: 'Задание на печать создано',
		jobCreatedFormHeading: 'Поздравляем!',
		accessCode: 'Код',
		congratsHtmlTemplate: 
		`<p>Вы только что успешно создали новую задачу в споте <em>“{name}”</em> по адресу <em>{address}</em>.</p> 
		<p>Используйте код <em>{accessCode}</em> для того, чтобы распечатать файлы.</p>
		<p>Мы также послали копию этого сообщения на ваш адрес <em>{email}</em></p>`,
		language: "Язык",
		disclaimerInstallAppTitle: "Установите мобильное приложение",
		disclaimerInstallAppText: "У нас есть удобное приложение. Установить?"
	}
};

const getLocalizedDistance = (m, l) => {
	switch (l) {
		case 'en': return Helpers.k2m(m);
		default:   return Helpers.m2m(m);
	}
}

export { getLocalizedDistance, messages };